/**
 * Created by Wang on 2021/4/12.
 */

import tools from '../../tools'

export default {
    name: 'expoolPicture',
    watch: {
        //如果路由发生了变化，更新页面数据
        $route(to, from) {
            if (to.path !== from.path) {
                if (this.exercisePoolId != this.$route.params.exercisePoolId || this.singleImageActiveIndex != this.$route.params.index) {
                    this.exercisePoolId = this.$route.params.exercisePoolId;
                    this.singleImageActiveIndex = parseInt(this.$route.params.index);
                    this.jing = this.$route.params.jing;
                    this.Statu = this.$route.params.Statu
                    this.init();
                }
            }
        }
    },
    data() {
        return {
            exercisePoolId: this.$route.params.exercisePoolId,
            jing:this.$route.params.jing,
            Statu: this.$route.params.Statu,
            exercisePoolPictureList: [],
            exercisePoolPictureList_Origin: [], //源数据，用于翻页时对比是否有更改，提示用户保存

            //单图模态框
            singleImageData: {},
            singleImageActiveIndex: parseInt(this.$route.params.index),

            //图片页码状态
            reviewPictureTotalCount: 0, //图片总数量
            reviewPictureCount: 0, //已标注图片数量
            catalogPictureList: [], //目录页页码和状态
            answerPictureList: [], //答案页页码和状态
            exercisePictureList: [], //习题页页码和状态
            repeatPageCount: 0, //重复页数量

            //审核完成习题题号模态框
            isShowExPageReview: false,
            isHaveNoReviewExPage: false, //是否有未审核的，有的话都审核完毕弹模态框。没有的话不弹

            isReviewBtnLoading: false, //审核按钮小loading

            //图片放大
            enlargeList: ["50%", "75%", "100%", "125%", "150%", "175%", "200%"],
            enlargeIndex: 2,
        }
    },
    created() {
        let that = this;
        that.init();
        this.$emit("header", false);
        this.$emit("footer", false);
    },
    mounted: function () {
        let _this = this;
        this.$nextTick(function () {
            _this.ShortcutKey();
        })
    },
    updated: function () {

    },
    methods: {
        init: function () {
            let _this = this;
            _this.getPictureByExercisePool(function () {
                _this.showSingleImage(_this.exercisePoolPictureList[_this.singleImageActiveIndex], _this.singleImageActiveIndex);
            });
            _this.getPictureCountByExercisePool(function () {
                if (_this.reviewPictureCount == _this.reviewPictureTotalCount) {
                    _this.isHaveNoReviewExPage = false;
                } else {
                    _this.isHaveNoReviewExPage = true;
                }
            });
        },
        //获取题库图片
        //排序方式: 页码排序按pictureType（图片类别）分类,再按照页码排序。时间排序不按pictureType分类，只看时间
        getPictureByExercisePool: function (callback) {
            let _this = this;
            tools.api('OCR.SearchResourceByExercisePoolAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "orderBy": 0,
            }, (data) => {
                if (data && data.length > 0) {
                    let PictureList = [];
                    for (let item of data) {
                        let PictureItem = {};
                        PictureItem.ocrDate = item.CreateTime ? item.CreateTime.replace("T", " ").split(".")[0] : item.CreateTime;
                        PictureItem.page = item.PageNumber;
                        PictureItem.picture = item.ResourceId;
                        PictureItem.pictureUrl = tools.ConvertResourceUrl(item.ResourceId);
                        PictureItem.pictureStatus = item.MarkStatus;
                        PictureItem.pictureType = item.ResourceType;
                        PictureList.push(PictureItem);
                    }
                    _this.exercisePoolPictureList = PictureList;
                  
                    _this.exercisePoolPictureList_Origin = tools.cloneJson(PictureList);
                }

                if (typeof callback == "function") {
                    callback();
                }
            });
        },
        //获取题库统计
        getPictureCountByExercisePool: function (callback) {
            let _this = this;

            _this.reviewPictureTotalCount = 0;
            _this.reviewPictureCount = 0;
            _this.catalogPictureList = [];
            _this.answerPictureList = [];
            _this.exercisePictureList = [];
            _this.repeatPageCount = 0;

            tools.api('OCR.SearchResourceByExercisePoolAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "orderBy": 0,
            }, (data) => {
                if (data && data.length > 0) {
                    _this.reviewPictureTotalCount = data.length;
                    for (let item of data) {
                        let PictureItem = {};
                        PictureItem.page = item.PageNumber;
                        PictureItem.picture = item.ResourceId;
                        PictureItem.pictureStatus = item.MarkStatus;

                        if (item.ResourceType == 0) {
                            _this.catalogPictureList.push(PictureItem);
                        }
                        if (item.ResourceType == 1) {
                            _this.exercisePictureList.push(PictureItem);
                        }
                        if (item.ResourceType == 2) {
                            _this.answerPictureList.push(PictureItem);
                        }
                        if (item.MarkStatus >= 1) {
                            _this.reviewPictureCount++;
                        }
                    }

                    //判断习题页页码重复
                    for (let exPicture of _this.exercisePictureList) {
                        let temp = _this.exercisePictureList.filter(item => {
                            return item.page == exPicture.page;
                        })
                        if (temp && temp.length >= 2 && exPicture.page != 0) {
                            exPicture.isRepeatPage = true;
                            _this.repeatPageCount++;
                        } else {
                            exPicture.isRepeatPage = false;
                        }
                    }

                    if (typeof callback == "function") {
                        callback();
                    }
                }
            });
        },

        //改变图片类型
        changePictureType: function (el, num) {
            el.pictureType = num;
        },

        exPageReviewCommon: function (json, callback) {
            let _this = this;

            _this.isReviewBtnLoading = true;
            tools.api('OCR.SaveResourceStatusAsync', {
                "exercisePoolId": _this.exercisePoolId,
                "resourceList": json
            }, (data) => {
                _this.isReviewBtnLoading = false;
                //判断是否是最后一页
                let lastPage = false;
                if (_this.singleImageActiveIndex + 1 > _this.exercisePoolPictureList.length - 1) {
                    lastPage = true;
                }

                _this.getPictureByExercisePool(function () {
                    if (typeof callback == "function") {
                        callback();
                    }
                });
                _this.getPictureCountByExercisePool(function () {
                    //全都审核通过&&有未审核的，展示进度
                    if (_this.reviewPictureCount == _this.reviewPictureTotalCount && _this.isHaveNoReviewExPage) {
                        _this.showExPageReview();
                    }
                    //全部审核通过&&修改审核到最后一页，直接进入到目录页
                    if (_this.reviewPictureCount == _this.reviewPictureTotalCount && !_this.isHaveNoReviewExPage && lastPage) {
                        _this.gotoExercisePool();
                    }
                });
            });
        },
        //删除图片
        delPicture: function (resourceId, index) {
            let _this = this;
            let json = [{'resourceId': resourceId}];

            tools.alertconfim("请确认是否移除该页", '', function () {
                tools.api('OCR.RemoveResourceByExercisePoolAsync', {
                    "exercisePoolId": _this.exercisePoolId,
                    "resourceList": json
                }, (data) => {
                    _this.getPictureByExercisePool(function () {
                        _this.showSingleImage(_this.exercisePoolPictureList[_this.singleImageActiveIndex], _this.singleImageActiveIndex);
                    });
                    _this.getPictureCountByExercisePool();
                    //1111111
                    //如果删除最后一个
                    if (index == _this.exercisePoolPictureList.length - 1) {
                        let lastCount = _this.exercisePoolPictureList.length - 2;
                        if (lastCount < 0) {
                            lastCount = 0;
                        }
                        _this.singleImageActiveIndex = lastCount;
                    }
                });
            });
        },

        //单图模式
        showSingleImage: function (item, index) {
            
            this.singleImageData = item;
            this.singleImageActiveIndex = index;
            
        },
        //上一张
        prevPictureSingleImage: function () {
            let _this = this;
            try {
                let isSame = _this.comparisonDataChanges([_this.singleImageActiveIndex]);
                if (!isSame) {
                    tools.alertconfim("是否确定修改？", "", function () {
                        _this.exPageReviewSingleImage("prev");
                    })
                    return false;
                }
            } catch (e) {
                console.log(e);
            }

            _this.singleImageActiveIndex = _this.singleImageActiveIndex - 1;
            if (_this.singleImageActiveIndex < 0) {
                _this.singleImageActiveIndex = 0;
            }
            _this.singleImageData = _this.exercisePoolPictureList[_this.singleImageActiveIndex];
        },
        //下一张
        nextPictureSingleImage: function () {
            let _this = this;
            try {
                let isSame = _this.comparisonDataChanges([_this.singleImageActiveIndex]);
                if (!isSame) {
                    tools.alertconfim("是否确定修改？", "", function () {
                        _this.exPageReviewSingleImage();
                    })
                    return false;
                }
            } catch (e) {
                console.log(e);
            }

            _this.singleImageActiveIndex = _this.singleImageActiveIndex + 1;
            if (_this.singleImageActiveIndex > _this.exercisePoolPictureList.length - 1) {
                _this.singleImageActiveIndex = _this.exercisePoolPictureList.length - 1;
            }
            _this.singleImageData = _this.exercisePoolPictureList[_this.singleImageActiveIndex];
        },
        //序号第几页
        indexPicture: function (picture) {
            let _this = this;
            _this.exercisePoolPictureList.forEach(function (item, index) {
                if (item.picture == picture) {
                    _this.singleImageActiveIndex = index;
                    _this.singleImageData = _this.exercisePoolPictureList[_this.singleImageActiveIndex];
                }
            })
        },
        //单图审核
        exPageReviewSingleImage: function (direction) {
            let _this = this;
            
            tools.putLoading();
            if (_this.singleImageData.pictureStatus == 0) {
                _this.singleImageData.pictureStatus = 1;
            }
            let json = [{
                'resourceId': _this.singleImageData.picture,
                'pageNumber': _this.singleImageData.page,
                'resourceType': _this.singleImageData.pictureType,
                'markStatus': _this.singleImageData.pictureStatus
            }];
            _this.exPageReviewCommon(json, function () {
                //如果有未标注的，找第一个未标注的
                let noStatusList = _this.exercisePoolPictureList.filter(function (item) {
                    return item.pictureStatus == 0;
                })

                if (noStatusList && noStatusList.length > 0) {
                    let picture = noStatusList[0].picture;
                    _this.exercisePoolPictureList.forEach(function (item, index) {
                        if (item.picture == picture) {
                            _this.singleImageActiveIndex = index;
                            _this.singleImageData = _this.exercisePoolPictureList[_this.singleImageActiveIndex];
                        }
                    })
                } else {
                    if (direction && direction == "prev") {
                        _this.prevPictureSingleImage();
                    } else {
                        _this.nextPictureSingleImage();
                    }
                }

                //图片加载完成后，再取消loading，最长时间5S
                $(".imgbox>img").get(0).onload = function () {
                    tools.deleteLoading();
                }
                setTimeout(function () {
                    tools.deleteLoading();
                }, 5000)
            })
        },

        //最后一个审核通过，展示进度
        showExPageReview: function () {
            this.isShowExPageReview = true;
        },
        closeExPageReview: function () {
            this.isShowExPageReview = false;
        },

        //对比数据改变(如已改变，则提示数据改变，需要保存修改)
        comparisonDataChanges: function (indexList) {
            let _this = this;
            let isSame = true; //默认相同为true
            for (let i = 0; i < indexList.length; i++) {
                let index = indexList[i];
                let item = _this.exercisePoolPictureList[index];
                let item_Origin = _this.exercisePoolPictureList_Origin[index];
                if (item.pictureType != item_Origin.pictureType || item.page != item_Origin.page) {
                    isSame = false;
                }
            }
            return isSame;
        },

        //去题库页
        gotoExercisePool: function () {
            tools.deleteCookie("ExpoolActiveChapterId" + this.exercisePoolId);
            this.$router.push("/ocr/expool/" + this.exercisePoolId+"/"+this.jing+'/'+this.Statu);
        },

        //图片放大
        changeEnlargeIndex: function (index) {
            this.enlargeIndex = index;
        },

        //快捷键设置
        ShortcutKey: function () {
            let _this = this;
            try {
                // 第一个Tab首次定位到左边的页码，再按一次Tab定位到右边页码，回车进入下一页
                // 键盘的左右键控制上一批下一批
                document.addEventListener("keydown", function (e) {
                    let key = e.which || e.keyCode;
                    if (key === 9) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Tab");
                        $("input").get(0).select();
                    }
                    if (key === 13) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Enter");
                        _this.exPageReviewSingleImage();
                    }
                    if (key === 37) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Left arrow");
                        _this.prevPictureSingleImage();
                    }
                    if (key === 39) {
                        event.stopPropagation();
                        event.preventDefault();

                        console.log("Right arrow");
                        _this.nextPictureSingleImage();
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },
    }
}